var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-upload-dragger",class:{
    'is-dragover': _vm.dragover
  },on:{"dragleave":function($event){$event.preventDefault();_vm.dragover = false},"dragover":function($event){$event.preventDefault();return _vm.onDragover.apply(null, arguments)},"drop":function($event){$event.preventDefault();return _vm.onDrop.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }